import { FC } from 'react';

import { ImageComponent } from '@/components/Image';
import { JackpotGemsDefaultPack } from '@/modules/jackpot/components/JackpotGemsPack';
import { useCommonStore } from '@/store';

import { ScBackground, ScBackgroundProps } from './styled';

export const Background: FC<ScBackgroundProps> = (props) => {
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  return (
    <ScBackground {...props}>
      <div className="bg">
        <ImageComponent
          src={isMobileDevice ? '/jackpot/mobBg.webp' : '/jackpot/bg.webp'}
          fill
          priority
          alt="jackpot bg"
        />
      </div>
      <div className="round-decor" />

      <JackpotGemsDefaultPack />
    </ScBackground>
  );
};
